import script from "./OnboardingAiLoadingStep.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingAiLoadingStep.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingAiLoadingStep.vue?vue&type=style&index=0&id=311dcfee&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-311dcfee"]])

export default __exports__